import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Flex, Input, Tabs, Upload, Select, Spin, Table, Pagination, Modal } from 'antd';
import { apiUrls } from '../apiUrls.js';
import { toast } from 'react-toastify';
import AmountFormat from "../components/AmountFormat.js";
import { CommentOutlined } from '@ant-design/icons';

const { Option } = Select;
const baseURL = apiUrls.baseURL;

const ProgramComments = React.memo(({ data, programKey }) => {

    const [isShowModalVisible, setIsShowModalVisible] = useState(false);
    const [dataComments, setDataComments] = useState([]);
    const [commentapi, setCommentapi] = useState('');
    const [loadingComments, setLoadingComments] = useState(false);

    useEffect(() => {
        getCommentapi()
    }, [])

    const getCommentapi = () => {
        switch (programKey) {
            case 'mountaineering':
                setCommentapi('GetMountaineeringProgramComments');
                break;
            case 'climbing':
                setCommentapi('GetClimbingProgramComments');
                break;
            case 'iceclimbing':
                setCommentapi('GetIceClimbingProgramComments');
                break;
            case 'trial':
                setCommentapi('GetTrialProgramComments');
                break;
            case 'caving':
                setCommentapi('GetCavingProgramComments');
                break;
            case 'bicycling':
                setCommentapi('GetBicyclingProgramComments');
                break;
            case 'canyoneering':
                setCommentapi('GetCanyoningProgramComments');
                break;
            case 'skyrunning':
                setCommentapi('GetSkyRunningProgramComments');
                break;
            case 'education':
                setCommentapi('GetEducationProgramComments');
                break;
        }
    }

    const getComments = async () => {
        setIsShowModalVisible(true);
        setLoadingComments(true);
        setDataComments([]);
        try {
            const token = localStorage.getItem('damavandclub-token')
            let response = await axios.get(`${apiUrls.baseURL}/program/${commentapi}?id=${data.id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            setDataComments(response.data.data)
        } catch (error) {
            toast.error(error.response.data.Msg, {
                position: 'bottom-right',
                autoClose: 3000, // milliseconds
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } finally {
            setLoadingComments(false);
        }
    };

    return (
        <>
            <Button size='small' className="program-action-button" icon={<CommentOutlined />} onClick={() => getComments()}
                style={{ backgroundColor: 'rgba(1, 60, 11, 0.85)' }}
                type="primary"><label>نظرات</label></Button>

            <Modal
                className="program-comments-modal"
                centered
                zIndex={1100}
                title={`نظرات برنامه :  ${data.nameFa}`}
                open={isShowModalVisible}
                width={760}
                okButtonProps={null}
                footer={
                    <Button onClick={() => setIsShowModalVisible(false)}>بستن</Button>
                }
                onCancel={() => setIsShowModalVisible(false)}
            >
                <div className="program-comments-content" dir="rtl">
                    {loadingComments ? <div className="program-comments-state"><Spin size="large" /></div> : dataComments.length > 0 ? (
                        <div className="program-comments-list">
                            {dataComments.map((item, index) => (
                                <article className="program-comment-card" key={item.id || index}>
                                    <div className="program-comment-member">
                                        <span>عضو برنامه</span>
                                        <strong>{item.memberName || 'عضو'}</strong>
                                    </div>
                                    {item.memberComment ? <div className="program-comment-text is-member-comment"><small>نظر عضو</small><p>{item.memberComment}</p></div> : null}
                                    {item.leaderComment ? <div className="program-comment-text is-leader-comment"><small>نظر سرپرست</small><p>{item.leaderComment}</p></div> : null}
                                    {!item.memberComment && !item.leaderComment ? <div className="program-comment-no-text">متنی برای این نظر ثبت نشده است.</div> : null}
                                </article>
                            ))}
                        </div>
                    ) : <div className="program-comments-state">هنوز نظری برای این برنامه ثبت نشده است.</div>}
                </div>
            </Modal>
        </>
    );
});

ProgramComments.propTypes = {
    data: PropTypes.any,
    programKey: PropTypes.string,
};

ProgramComments.displayName = 'ProgramComments';

export default ProgramComments;
